import React, { useState } from 'react';

import AdminMenu from '../../../../components/Admin/MenuDetalhes/AdminMenu';
import { Container, Title } from './styles';
import { producaov2 } from '../../../../services/apis';
import { FormsStepper } from './components';
import { Tab, Tabs, ThemeProvider, createMuiTheme as createTheme } from '@material-ui/core';
import BoletoModal from './components/BoletoModal';
import BoletosList from './components/BoletosList';
import BoletoSubscription from './components/BoletoSubscription';

const theme = createTheme({
  palette: {
    primary: {
      main: '#FF7417',
      contrastText: '#FFF'
    },
  },
  typography: {
    fontFamily: 'Montserrat, Arial'
  }
});

export default function PagarmeBoleto() {
  const [boleto, setBoleto] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  const handleFormSubmit = async ({ customer, address, payment, openLast }) => {
    setIsModalOpen(true);
    
    if(openLast) {
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const response = await producaov2.post('/admin/boletos', {
        client: {
          id: customer?.user?.id,
          name: customer?.isCompany ? customer?.companyName : customer?.user?.name,
          email: customer?.isCompany ? customer?.email : customer?.user?.email,
          document: customer?.document,
          phone: customer?.phone,
          documentType: customer?.isCompany ? 'cnpj' : 'cpf'
        },
        address,
        payment: {
          courseID: payment?.product?.id,
          description: payment?.product?.name,
          price: payment?.price,
          instructions: payment?.instructions,
          notes: payment?.notes,
          ...(payment?.needInstallments && {installments: payment?.installments,}),
          dueAt: payment?.dueAt
        }
      });

      setBoleto(response.data);
    } catch (requestError) {
      // Sem isso a modal ficava em "Carregando Boleto..." pra sempre e o operador
      // clicava em gerar de novo, criando cobranças duplicadas na Pagarme.
      setBoleto(null);
      setError(requestError?.response?.data?.message || 'Não foi possível gerar o boleto. Verifique os dados e tente novamente.');
    } finally {
      setIsLoading(false);
    }
  }

  const handleCloseModal = () => {
    setIsModalOpen(false);
  }

  const handleChangeTab = (event, newTabIndex) => {
    setTabIndex(newTabIndex);
  };

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>

    <ThemeProvider theme={theme}>
      <AdminMenu />
      <Container>
        <Tabs value={tabIndex} onChange={handleChangeTab} variant="fullWidth">
          <Tab label="Boletos" />
          <Tab label="Criar Boleto" />
          <Tab label="Criar Assinatura" />
        </Tabs>
        {tabIndex === 0 && (
          <>
            <BoletosList />
          </>
        )}
        {tabIndex === 1 && (
          <>
            <FormsStepper onSubmit={handleFormSubmit} boleto={boleto} />
            <BoletoModal isOpen={isModalOpen} isLoading={isLoading} boleto={boleto} error={error} onClose={handleCloseModal}/>
          </>
        )}
        {tabIndex === 2 && (
          <>
            <BoletoSubscription />
          </>
        )}
      </Container>
    </ThemeProvider>
    </div>
  );
}